import {createAsyncThunk} from '@reduxjs/toolkit';

import {TRequestTableResponseWithPagination} from 'shared/types/requests';
import {IRpcDeleteResponse} from 'shared/types/rpc';

import {
    fetchFlexFieldsSettingsTable,
    fetchFlexFieldsSegmentsTable,
    IFetchFlexFieldsSettingsTableParams,
    IFetchFlexFieldsSegmentsTableParams,
    fetchFlexFieldsRecord,
    IFetchFlexFieldRecordParams,
    putFlexFieldsRecord,
    IUpdateFlexFieldRecordParams,
    deleteFlexFieldsSettingsTableRowsRequest,
    IDeleteFlexFieldsSettingsTableRowsParams,
    postFlexFieldsContext,
    IPostFlexFieldsContextParams,
    IUpdateFlexFieldsContextParams,
    putFlexFieldsContext,
    IDeleteFlexFieldsSegmentsTableRowsParams,
    deleteFlexFieldsSegmentsTableRowsRequest,
    IPostFlexFieldsSegmentParams,
    IUpdateFlexFieldsSegmentParams,
    postFlexFieldsSegment,
    putFlexFieldsSegment,
} from './flex-fields-slice-api';
import {FLEX_FIELDS_SLICE} from './flex-fields-slice-constants';
import {IFlexFieldRecordDto, IFlexFieldsSegmentsTableDto, IFlexFieldsSettingsTableDto} from './flex-fields-slice-types';

// ==== Thunks to work with Flex Field Settings Table ====
export const loadFlexFieldsSettingsTable = createAsyncThunk<
    TRequestTableResponseWithPagination<IFlexFieldsSettingsTableDto>,
    IFetchFlexFieldsSettingsTableParams>(
        `${FLEX_FIELDS_SLICE}/loadFlexFieldsSettingsTable`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await fetchFlexFieldsSettingsTable(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const deleteFlexFieldsSettingsTableRows = createAsyncThunk<
    IRpcDeleteResponse,
    IDeleteFlexFieldsSettingsTableRowsParams>(
        `${FLEX_FIELDS_SLICE}/deleteFlexFieldsSettingsTableRows`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await deleteFlexFieldsSettingsTableRowsRequest(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

// ==== Thunks to work with Flex Field Segments Table ====
export const loadFlexFieldsSegmentsTable = createAsyncThunk<
    TRequestTableResponseWithPagination<IFlexFieldsSegmentsTableDto>,
    IFetchFlexFieldsSegmentsTableParams>(
        `${FLEX_FIELDS_SLICE}/loadFlexFieldsSegmentsTable`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await fetchFlexFieldsSegmentsTable(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const deleteFlexFieldsSegmentsTableRows = createAsyncThunk<
    IRpcDeleteResponse,
    IDeleteFlexFieldsSegmentsTableRowsParams>(
        `${FLEX_FIELDS_SLICE}/deleteFlexFieldsSegmentsTableRows`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await deleteFlexFieldsSegmentsTableRowsRequest(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

// ==== Thunks to work with Flex Field Record Object Form ====
export const loadFlexFieldRecord = createAsyncThunk<IFlexFieldRecordDto,
    IFetchFlexFieldRecordParams>(
        `${FLEX_FIELDS_SLICE}/loadFlexFieldRecord`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await fetchFlexFieldsRecord(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const updateFlexFieldRecord = createAsyncThunk<string,
    IUpdateFlexFieldRecordParams>(
        `${FLEX_FIELDS_SLICE}/updateFlexFieldRecord`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await putFlexFieldsRecord(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

// ==== Thunks to work with Flex Field Context Form ====
export const createFlexFieldsContext = createAsyncThunk<string,
    IPostFlexFieldsContextParams>(
        `${FLEX_FIELDS_SLICE}/createFlexFieldsContext`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await postFlexFieldsContext(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const updateFlexFieldsContext = createAsyncThunk<string,
    IUpdateFlexFieldsContextParams>(
        `${FLEX_FIELDS_SLICE}/updateFlexFieldsContext`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await putFlexFieldsContext(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

// ==== Thunks to work with Flex Field Segment Form ====
export const createFlexFieldsSegment = createAsyncThunk<string,
    IPostFlexFieldsSegmentParams>(
        `${FLEX_FIELDS_SLICE}/createFlexFieldsSegment`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await postFlexFieldsSegment(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const updateFlexFieldsSegment = createAsyncThunk<string,
    IUpdateFlexFieldsSegmentParams>(
        `${FLEX_FIELDS_SLICE}/updateFlexFieldsSegment`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await putFlexFieldsSegment(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );
